import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  initialize() {
    if(localStorage.getItem("window-scroll")) {
      window.scrollTo(0, localStorage.getItem("window-scroll"))
      localStorage.removeItem("window-scroll")
    }
  }

  clicked() {
    localStorage.setItem("window-scroll", window.scrollY);
  }
}
